module.exports = __webpack_public_path__ + "static/media/games.3e16c28b.svg";